Object.defineProperty(exports, "__esModule", {
  value: true
});
var tableContent = {
  content: '" "',
  display: 'table'
};

var clearfix = {
  ':before': tableContent,
  ':after': Object.assign({}, tableContent, {
    clear: 'both'
  })
};

exports['default'] = clearfix;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/clearfix.js
// module id = 442
// module chunks = 168707334958949